import styled from 'styled-components';

export const Icon = styled.div`
  color: ${(props) => props.theme.primaryColor};
  position: absolute;
  right: -8px;
  top: 0;
  font-size: 18px;
  line-height: 18px;

  &:hover {
    cursor: pointer;
  }

  @media screen and (min-width: ${(props) => props.theme.medium}) {
    right: -5px;
    top: 10px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 40px;
  padding-top: 5px;
  position: relative;
  @media screen and (min-width: ${(props) => props.theme.medium}) {
    padding-top: 15px;
  }
`;

export const WrapperText = styled.div`
  font-size: 12px;
  width: 100%;
  overflow: hidden;
  background: #1f242e;
  height: ${(props) => props.height || 'auto'};
  transition: height 0.3s linear;
`;

export const TextCol = styled.div`
  display: grid;
  margin: 10px 10px;
  grid-template-columns: 105px auto;

  > span:first-child {
    font-weight: 500;
    margin-right: 10px;
  }
  > span.emphasize {
    color: ${(props) => props.theme.primaryColor};
  }

  @media screen and (min-width: ${(props) => props.theme.small}) {
    margin: 0 10px;
    display: flex;
    flex: 1 0;
  }
  a {
    color: ${(props) => props.theme.linkColor};
  }
`;

export const Arrow = styled.button`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 8px solid black;
  padding: 0px;
  margin-top: 5px;

  &:focus {
    outline: none;
  }
  @media screen and (min-width: ${(props) => props.theme.small}) {
    margin-top: 20px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media screen and (min-width: ${(props) => props.theme.small}) {
    flex-direction: row;
  }
`;

export const InfoText = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 5px 0 5px 0;
  @media screen and (min-width: ${(props) => props.theme.small}) {
    padding: 24px 0 5px 0;
  }
`;
